import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { Button } from '../../components/common'
import { ampEvent, ampSetUserProperty } from '../../utils/amplitude'
import {
	getDiscount,
	getEmail,
	getError,
	getFlowTag,
	getFlowType,
	getIsLegalFlow,
	getIsUnsubscribeShown,
	getUserId,
} from '../../redux/slices/userSlice'

import './styles.scss'
import { paramsToQuery } from '../../utils/historyDecorators'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'

const ErrorScreen = props => {
	const error = useSelector(getError)
	const isLegalFlow = useSelector(getIsLegalFlow)
	const flow_type = useSelector(getFlowType)
	const flow_tag = useSelector(getFlowTag)
	const email = useSelector(getEmail)
	const user_id = useSelector(getUserId)
	const upsell_test = useSelector(getUpsellPrice)
	const initial_price = useSelector(getInitialPrice)
	const discount = useSelector(getDiscount)
	const isUnsubscribeShown = useSelector(getIsUnsubscribeShown)

	const history = useHistory()

	useEffect(() => {
		ampSetUserProperty('error', error, user_id)
		ampEvent('Error_screen')
	}, [])

	const buttonHandler = () => {
		if (!discount.includes('/discount')) {
			if (isUnsubscribeShown) {
				return history.push({
					pathname: `/unsubscribe/offer`,
					search: paramsToQuery({
						user_id,
						external_id: user_id,
						modal: true,
						email: decodeURIComponent(email),
					}),
				})
			}
			if (props.location?.state?.flow === 'cartoonify') {
				history.push({
					pathname: '/',
					search: isLegalFlow
						? paramsToQuery({
								user_id,
								external_id: user_id,
								flow: 33,
						  })
						: paramsToQuery({
								user_id,
								external_id: user_id,
								upsell_test,
								initial_price,
								flow: 33,
						  }),
				})
			} else {
				switch (flow_tag) {
					case '': {
						if (flow_type === '1') {
							return history.push({
								pathname: '/sale-1',
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						} else {
							return history.push({
								pathname: '/sale-2',
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						}
					}
					case '11': {
						if (flow_type === '1') {
							return history.push({
								pathname: '/sale11-1',
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						} else {
							return history.push({
								pathname: '/sale11-2',
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						}
					}
					case '22': {
						if (flow_type === '3') {
							return history.push({
								pathname: `/sale22-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						} else {
							return history.push({
								pathname: `/sale22-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						}
					}
					case '33': {
						if (flow_type === '5') {
							return history.push({
								pathname: `/sale33-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						} else {
							return history.push({
								pathname: `/sale33-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						}
					}
					case '55': {
						if (flow_type === '9') {
							return history.push({
								pathname: `/sale55-${isLegalFlow ? '3' : '1'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						} else {
							return history.push({
								pathname: `/sale55-${isLegalFlow ? '4' : '2'}`,
								search: isLegalFlow
									? paramsToQuery({
											user_id,
											external_id: user_id,
											modal: true,
											email: decodeURIComponent(email),
									  })
									: paramsToQuery({
											user_id,
											external_id: user_id,
											upsell_test,
											initial_price,
											modal: true,
											email: decodeURIComponent(email),
									  }),
							})
						}
					}
					default: {
						return ''
					}
				}
			}
		} else {
			history.push({
				pathname: `/discount${isLegalFlow ? '' : '11'}`,
				search: isLegalFlow
					? paramsToQuery({
							user_id,
							external_id: user_id,
							modal: true,
							email: decodeURIComponent(email),
					  })
					: paramsToQuery({
							user_id,
							external_id: user_id,
							upsell_test,
							initial_price,
							modal: true,
							email: decodeURIComponent(email),
					  }),
			})
		}
	}

	return (
		<div className="error">
			<div className="error-info">
				<img
					src="/images/error/error.png"
					alt="error"
					className="error-info__image"
				/>
				<h1 className="error-info__title">Ooops</h1>
				<p className="error-info__description">
					{props.location?.state?.flow !== 'cartoonify' &&
						'Sorry, your transaction failed:'}
					<br />
					{error}
				</p>
				<Button buttonText="Try again" onClick={buttonHandler} />
			</div>
		</div>
	)
}

export { ErrorScreen }
